import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { useEventCallback } from './useEventCallback';
import { useRefWithCurrentValue } from './useRefWithCurrentValue';
export function useResizeObservedElement(options) {
  const $ = _c(11);
  const [observeOptions, setObserveOptions] = useState(options.observeOptions);
  const observeOptionsRef = useRefWithCurrentValue(observeOptions);
  let t0;
  if ($[0] !== options) {
    t0 = (...t1) => {
      const args = t1;
      options.callback(...args);
    };
    $[0] = options;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const callback = useEventCallback(t0);
  let t1;
  let t2;
  if ($[2] !== observeOptionsRef || $[3] !== options.observeOptions) {
    t1 = () => {
      if (JSON.stringify(options.observeOptions) !== JSON.stringify(observeOptionsRef.current)) {
        setObserveOptions(options.observeOptions);
      }
    };
    t2 = [observeOptionsRef, options.observeOptions];
    $[2] = observeOptionsRef;
    $[3] = options.observeOptions;
    $[4] = t1;
    $[5] = t2;
  } else {
    t1 = $[4];
    t2 = $[5];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[6] !== callback || $[7] !== observeOptions || $[8] !== options.element) {
    t3 = () => {
      const observer = new ResizeObserver(callback);
      if (options.element) {
        observer.observe(options.element, observeOptions);
      }
      return () => {
        observer.disconnect();
      };
    };
    t4 = [options.element, observeOptions, callback];
    $[6] = callback;
    $[7] = observeOptions;
    $[8] = options.element;
    $[9] = t3;
    $[10] = t4;
  } else {
    t3 = $[9];
    t4 = $[10];
  }
  useEffect(t3, t4);
}
export type UseResizeObserverOptions = {
  element: Element | null;
  observeOptions?: ResizeObserverOptions;
  callback: ResizeObserverCallback;
};